import axios from "axios";
import url from "../config/urlServiceConfig";

const soAPI = {
  getAll: () => axios.get(url.strategicObjective),
  getById: (id) => axios.get(`${url.strategicObjective}/${id}`),
  create: (body) => axios.post(url.strategicObjective, body),
  update: (body) => axios.put(url.strategicObjective, body),
  delete: (id) => axios.delete(`${url.strategicObjective}/${id}`),
  getAllWithKPIs: () => axios.get(`${url.strategicObjective}/KPIs`),
  getByIdWithKPIs: (id) => axios.get(`${url.strategicObjective}/KPIs/${id}`),
};

export default soAPI;
